// src/utils/stockPriceUpdater.js
import { doc, updateDoc, collection, getDocs, serverTimestamp } from 'firebase/firestore';
import { db } from '../services/firebase/config';

const STOCK_UPDATER_URL = process.env.REACT_APP_STOCK_UPDATER_URL  

export async function updateStockPrices(userEmail, portfolioId) {
  if (!portfolioId) {
    throw new Error('Portfolio ID is required');
  }

  try {
    // Get all positions from the selected portfolio
    const portfolioDoc = doc(db, 'users', userEmail, 'portfolios', portfolioId);
    const positionsRef = collection(portfolioDoc, 'positions');
    const positionsSnapshot = await getDocs(positionsRef);
    
    // Get symbols to update
    const symbols = positionsSnapshot.docs
      .filter(doc => !doc.id.endsWith('CURRENCY'))
      .map(doc => doc.id);
      
    if (symbols.length === 0) {
      return {
        success: true,
        message: 'No positions to update',
        details: []
      };
    }

    // Call Firebase Function to get updated prices
    const response = await fetch(STOCK_UPDATER_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ symbols })
    });

    if (!response.ok) {
      throw new Error('Failed to fetch prices');
    }

    const { results } = await response.json();

    // Update Firestore documents with new prices and technical indicators
    const updatePromises = results
      .filter(result => result.success)
      .map(async ({ 
        symbol, 
        price, 
        rsi1h, 
        ema7_1h, 
        ema21_1h, 
        ema55_1h, 
        ema100_1h 
      }) => {
        const positionRef = doc(portfolioDoc, 'positions', symbol);
        await updateDoc(positionRef, {
          lastPrice: price,
          rsi1h: rsi1h,
          ema7_1h: ema7_1h,
          ema21_1h: ema21_1h,
          ema55_1h: ema55_1h,
          ema100_1h: ema100_1h,
          updatedAt: serverTimestamp(),
          lastUpdated: serverTimestamp()
        });
        return { 
          symbol, 
          success: true, 
          price, 
          rsi1h, 
          ema7_1h, 
          ema21_1h, 
          ema55_1h, 
          ema100_1h 
        };
      });

    await Promise.all(updatePromises);
    
    // Return results
    const totalUpdates = results.length;
    const successfulUpdates = results.filter(r => r.success).length;
    
    return {
      success: true,
      message: `${successfulUpdates} / ${totalUpdates} pozisyon güncellendi`,
      details: results
    };
    
  } catch (error) {
    console.error('Fiyat güncelleme hatası:', error);
    throw new Error(`Fiyat güncellemesi başarısız: ${error.message}`);
  }
}